import { wlConfigRequest } from "src/services/white-label/request";
import poliConfig from "./poliConfig";

declare global {
  interface Window {
    keepAliveInterval: NodeJS.Timeout | null;
  }
}

const TIME_TO_ALIVE = parseInt(process.env.REACT_APP_TIME_TO_ALIVE || '60000');

export function initKeepAliveInterval(keepAliveSession: () => void) {
    window.keepAliveInterval = setInterval(
        keepAliveSession,
        TIME_TO_ALIVE
      );
}

export function clearKeepAliveInterval() {
    if (window.keepAliveInterval) {
        clearInterval(window.keepAliveInterval);
        window.keepAliveInterval = null;
      }
}
export async function checkDomain() {
  const env = process.env.REACT_APP_ENV;
  const domain = window.location.hostname;
  const poliAppLaravelUrl = poliConfig.poliAppLaravelUrl;
  const storageLaravelUrl = window.localStorage.getItem('current_laravel_url');

  const isPoliDomain = domain.includes('poli'); // Verifica se o domínio é da POLI
  const isPoliLaravelUrl = poliAppLaravelUrl?.includes('poli'); // Verifica se a url do laravel é da POLI
  const hasValidLaravelUrl = storageLaravelUrl && !storageLaravelUrl.includes('poli'); // Verifica se a URL armazenada no localStorage não é do POLI

  
  if (env === 'production') {
    // Se não for domínio da POLI e não tiver url do laravel armazenada no localStorage 
    // ou se a url do laravel for da POLI, busca a url no endpoint de reseller
    if (!isPoliDomain && (!hasValidLaravelUrl || isPoliLaravelUrl)) {
      try {
        const response = await wlConfigRequest()

        if (!response.ok) {
          throw new Error('Falha ao obter dados do reseller');
        }

        const data = await response.json();
        window.localStorage.setItem('current_laravel_url', data.laravel_url);
      } catch (error) {
        console.error('Erro ao verificar reseller:', error);       
        return;
      }
    }
  }
  return;
}